module.exports = __webpack_public_path__ + "img/bg4.9a06c2c6.jpg";